import React, { useState } from "react";
import { toast } from "sonner";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { api } from "../lib/api";
import { useI18n } from "../contexts/I18nContext";

export default function ForgotPassword() {
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success(t("common.success"));
    } catch (err) {
      toast.error(err?.response?.data?.detail || t("common.error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <main className="min-h-[calc(100vh-64px)] flex items-center justify-center bg-[#FAFAFA] px-6">
        <div className="w-full max-w-md card-premium p-10">
          <h1 className="font-display font-bold text-3xl text-slate-900">{t("auth.forgotTitle")}</h1>
          <p className="mt-2 text-slate-600 text-sm">{t("auth.forgotSub")}</p>
          {sent ? (
            <div className="mt-8 text-slate-700 text-sm" data-testid="forgot-sent">
              {t("common.success")} — check your email.
            </div>
          ) : (
            <form onSubmit={submit} className="mt-8 space-y-5">
              <input
                type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full rounded-lg border border-slate-300 bg-white px-4 py-2.5 focus:border-[#0A192F] focus:ring-1 focus:ring-[#0A192F] outline-none transition"
                placeholder={t("auth.email")}
                data-testid="forgot-email"
              />
              <button disabled={loading} className="btn-primary w-full rounded-full px-6 py-3 font-semibold" data-testid="forgot-submit">
                {loading ? t("common.loading") : t("auth.sendLink")}
              </button>
            </form>
          )}
          <div className="mt-6 text-sm"><Link to="/login" className="text-[#0A192F] hover:underline">{t("common.back")}</Link></div>
        </div>
      </main>
    </>
  );
}
